<nav aria-label="breadcrumb">
  <ol class="breadcrumb">
    <li class="breadcrumb-item active" aria-current="page">
      <a [routerLink]="'/promotion-tools/redirect-rules'">Redirect links</a>
    </li>
    <li class="breadcrumb-item" aria-current="page">
      @if (isCreate()) {
        <span class="fs-5 fw-bold mb-0">Add link</span>
      }
      @if (!isCreate()) {
        <span class="fs-5 fw-bold mb-0">Edit link</span>
      }
    </li>
  </ol>
</nav>

@if (loaded) {
  <div class="card border-0 shadow mb-3 fade-in-zoom">
    <div class="card-body">
      <form [formGroup]="form" (ngSubmit)="onSubmit()" autocomplete="off">
        <div class="row g-3 mb-3">
          <div class="col-4">
            <label for="name" class="form-label">Name</label>
            <div class="input-group">
              <span class="input-group-text"><i class="bi bi-link-45deg"></i></span>
              <input type="url" class="form-control" id="name" placeholder="Name"
                     formControlName="name">
            </div>
          </div>

          <div class="col-4">
            <label for="domain" class="form-label">Domain</label>
            <div class="input-group">
              <span class="input-group-text"><i class="bi bi-box"></i></span>
              <select id="domain" class="form-select" formControlName="domainId">
                <option [ngValue]="null" disabled>Select product</option>
                @for (domain of availableDomains; track domain) {
                  <option [ngValue]="domain.id">{{ domain.domain }}</option>
                }
              </select>
            </div>
          </div>

          <div class="col-4">
            <label for="identifier" class="form-label">Identifier</label>
            <div class="input-group">
              <span class="input-group-text"><i class="bi bi-link-45deg"></i></span>
              <input type="url" class="form-control" id="identifier" placeholder="Identifier"
                     formControlName="identifier">
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-9">
            <label for="redirectUrl" class="form-label">Redirect URL</label>
            <div class="input-group">
              <span class="input-group-text"><i class="bi bi-link-45deg"></i></span>
              <input type="url" class="form-control" id="redirectUrl" placeholder="https://www.example.com"
                     formControlName="redirectUrl">
            </div>
          </div>

          <div class="col-3">
            <label class="form-label">Options</label>
            <app-input-switch id="copyQueryParameters" formControlName="copyQueryParameters">Copy query parameters
            </app-input-switch>
          </div>
        </div>

        <div class="row">
          <div class="col">
            <div class="row">
              <div class="col"></div>
              <div class="col-auto">
                <app-input-switch id="enabled" formControlName="enabled">Enabled</app-input-switch>
              </div>
            </div>
          </div>
        </div>

        <div class="row mt-5">
          <div class="col text-end">
            <button type="submit" class="btn btn-primary fw-bold">
              @if (isCreate()) {
                <span>Create</span>
              }
              @if (!isCreate()) {
                <span>Update</span>
              }
            </button>
          </div>
        </div>

      </form>
    </div>
  </div>
}
